module.exports = __webpack_public_path__ + "fonts/qtzain_bold_final.318b943d.woff";